import React from 'react';
import '../../App.css';
import Footer from "../Footer";
import PDFViewer from '../PDFViewer';
import CardItem from '../CardItem';
import { useEffect } from 'react';

function Junior() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <> 
            <div className='junior-bg'>
                <h1 className="page-title">Junior (Age: 6-8 y/o)</h1>
                <div className="subprogramme-container">
                    <div className="kad__container">
                        <div className="cards__wrapper">
                            <ul className="cards__items">
                                <CardItem 
                                src="images/junior.jpg"
                                text="Dive into Scratch, mechanics, and machine learning with Wedo to build a solid foundation in STEM."
                                label='Junior (6-8)'
                                path='/junior'
                                />
                            </ul>
                        </div>
                    </div>
                    <div className="subprogramme-pdf">
                        <PDFViewer path="pdf/Roblock-World-Program-Outline-Junior.pdf" />
                    </div>
                </div>
            </div>           
            <Footer />
        </>
    )
}

export default Junior
